import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
var Common = namespace('common');

var AnounceDetail = function (_super) {
  __extends(AnounceDetail, _super);

  function AnounceDetail() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.detailPending = false;
    _this.announceDetail = {};
    return _this;
  }

  Object.defineProperty(AnounceDetail.prototype, "id", {
    get: function get() {
      return this.$route.query.id;
    },
    set: function set(value) {
      return value;
    },
    enumerable: false,
    configurable: true
  });

  AnounceDetail.prototype.created = function () {
    this.initDetail();
  };

  AnounceDetail.prototype.initDetail = function () {
    if (!this.id) {
      this.$message.error(this.t('地址需有合法的公告id'));
    }

    this.queryAnnounceDetail();
  };

  AnounceDetail.prototype.queryAnnounceDetail = function () {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.detailPending = true;
            return [4, this.$api.announce.queryAnnounceDetail({
              id: this.id
            })];

          case 1:
            data = _a.sent().data;
            this.detailPending = false;
            this.announceDetail = {};
            this.announceDetail = data;

            if (data.acked === this.$enum.common.BoolIntEnum.NO) {
              this.ackAnnounce();
            }

            return [2];
        }
      });
    });
  };

  AnounceDetail.prototype.ackAnnounce = function () {
    return __awaiter(this, void 0, Promise, function () {
      var error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2, 3, 4]);

            return [4, this.$api.announce.ackAnnounce({
              id_list: [Number(this.id)]
            }, {
              showError: false,
              loading: false
            })];

          case 1:
            _a.sent();

            return [3, 4];

          case 2:
            error_1 = _a.sent();
            return [3, 4];

          case 3:
            this.$store.dispatch('user/updateUnreadTotal');
            return [7];

          case 4:
            return [2];
        }
      });
    });
  };

  AnounceDetail = __decorate([Component], AnounceDetail);
  return AnounceDetail;
}(Vue);

export default AnounceDetail;